export * from './pwa-install.component';
